<template>
  <div class="wrapper">
    <div class="head">
      <img :src="icon" />
      <span>{{name}}</span>
    </div>
    <div class="content">
        <div class="bg-stripe" />
        <div class="block">
          <div class="div1">
              <img :src="icon" />
              <span>{{name}}</span>
          </div>
          <div class="div2" v-html="list[0].text"></div>
          <div class="div3">
            <span  v-for="(item, index) in list" :key="index" class="block-img">
              <img :src="item.img" />
            </span>
          </div>
        </div>
        <div class="bg-white" />
    </div>
    <div class="footer">
      <p><a href="https://beian.miit.gov.cn/" target="_blank">{{copyright}}</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '首页',
      icon: '',
      title: '首页',
      list: []
    }
  },
  computed:{
    sdata() {
      return this.$store.state.data;
    }
  },
  created() {
    let data = this.sdata
    this.list = data.list
    this.name = data.name
    this.icon = data.icon
    this.copyright = data.copyright
    document.title = this.name
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  background: #fff;
  // 顶部导航栏
  .head {
    width: calc(100% - 1.5rem);
    padding: 0 .75rem;
    height: .45rem;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .11rem;
    color: #333;
    box-shadow: .01rem .02rem .1rem 0 rgba(49,41,55,0.3);
    img {
      width: .3rem;
      height: .3rem;
      margin-right: .14rem;
    }
  }
  .content {
    position: relative;
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    align-items: center;
    .bg-stripe {
      position: absolute;
      right: 0;
      top: 0;
      width: 1.5rem;
      height: 1.5rem;
      background: url('~@/assets/images/s2.png') no-repeat !important;
      background-size: 100% 100% !important;
    }
    .bg-white {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2rem;
      background: #fff;
      z-index: 1;
    }
    .block {
      display: flex;
      flex-flow: column;
      align-items: center;
      width: 100%;
      height: calc(100% - .8rem);
      background-image: linear-gradient(135deg, #6E6E6E 0%, #140A09 100%);
    }
    .div1 {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .45rem;
      color: #fff;
      margin: .6rem 0 .35rem 0;

      img {
        margin-right: .23rem;
        width: .85rem;
        height: .85rem;
        border-radius: .18rem;
      }
    }

    .div2{
      display: flex;
      justify-content: center;
      max-width: 8.5rem;
      margin-bottom: .35rem;
      font-size: .15rem;
      color: #fff;
      line-height: .26rem
    }

    .div3 {
      display: flex;
      width: 100%;
      max-width: 8.5rem;
      height: 3.4rem;
      justify-content: space-between;
      z-index: 2;
      margin-bottom: .3rem;
      .block-img {
        background: #FFFFFF;
        background: #FFFFFF;
        box-shadow: .01rem .01rem 0.3rem 0 rgba(0,0,0,0.50);
        border-radius: .15rem;
        width: 1.7rem;
        height: 3.1rem;
        padding: .08rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: .11rem;
          border: .005rem solid #ddd;
        }
      }
    }

  }

  // 底部备案
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: .5rem;
    background: #333;
    font-size: .1rem;
    color: #fff;
    a, a:visited {
      color: #fff;
    }
  }
}
</style>
